import React, { Component } from 'react';
import TextAndImage from './../../alpineComponents/textAndImage';

export default class PublicSpeakingTeaser extends Component {
  constructor(props) {
      super(props);
  }
  render() {
    return (
      <div className="medium-padding">
        <div className="max-width-container">
          <TextAndImage
            direction={"right"}
            ratio={"square"}
            resizeMode={"cover"}
            image="/images/speaking-home.jpg"
            title={'Work With Me'}
            description={'Author, adventurer, and public speaker, Kat Medina has traveled to more than 40 countries, and lived in Ecuador, Argentina, France, and Spain. She draws upon her passion for travel to inspire joy in others, teaching people how to show up and live fully by embodying a traveler’s mindset in daily life.'}
            buttonText={'Speaking Opportunities'}
            buttonLink={'/speakingOps'}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/publicSpeakingTeaser/index.js